
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/utils/analytics';
import { useSEO } from './useSEO';

// 页面标题映射
const PAGE_TITLES: Record<string, string> = {
  '/': 'Home - Resonow',
  '/client-auth': 'Client Login - Resonow',
  '/book-an-appointment': 'Find Practitioners - Resonow',
  '/practitioner-dashboard': 'Practitioner Dashboard - Resonow',
  '/client-dashboard': 'Client Dashboard - Resonow',
  '/admin-dashboard': 'Admin Dashboard - Resonow',
  '/about-us': 'About Us - Resonow',
  '/news-events': 'News & Events - Resonow',
  '/payment': 'Payment - Resonow',
  '/booking-success': 'Booking Success - Resonow',
  '/certifications': 'Certifications - Resonow',
};

// 检查是否在正确的 React 上下文中
const isValidReactContext = () => {
  try {
    return typeof window !== 'undefined' && 
           window.React !== undefined;
  } catch {
    return false;
  }
};

export const usePageTracking = () => {
  const location = useLocation();
  
  // Initialize SEO for current page with error boundary
  useSEO();

  useEffect(() => {
    try {
      // 获取页面标题
      const pageTitle = PAGE_TITLES[location.pathname] || document.title;
      
      // 追踪页面浏览
      trackPageView(location.pathname + location.search, pageTitle);
    } catch (error) {
      console.warn('Error in page tracking useEffect:', error);
    }
  }, [location]);
};
